import competitionEvents from "./config/competitionEvents";
import basePc from "./config/basePc";
import baseMb from "./config/baseMb";
import basePublish from "./config/basePublish";
import basePcThree from "./config/basePcThree";
import basePcFour from "./config/basePcFour";

const metaAuth = {
  auth: 1,
  keepAlive: false,
};

export default [
  {
    path: "/",
    name: "index",
    component: () => import("@/views/Home/index.vue"),
    children: [
      {
        path: "/",
        name: "indexs",
        component: () => import("@/views/Indexs/index.vue"),
      },
    ],
  },
  {
    path: "/",
    name: "indexs",
    component: () => import("@/views/Home/index.vue"),
    redirect: "/home",
    children: [
      // 首页
      {
        path: "/home",
        name: "homes",
        meta: metaAuth,
        component: () => import("@/views/Indexs/index.vue"),
      },
      {
        path: "/pr",
        name: "homes",
        meta: metaAuth,
        component: () => import("@/views/Indexs/index.vue"),
      },
      // 了不起的传奇人
      {
        path: "/cqbz",
        name: "cqbz",
        meta: metaAuth,
        component: () => import("@/views/cqbz/index.vue"),
      },
      // 资讯
      {
        path: "/news",
        name: "news",
        meta: metaAuth,
        component: () => import("@/views/News/index.vue"),
      },
      // 资讯
      {
        path: "/996news",
        name: "996news",
        meta: metaAuth,
        component: () => import("@/views/News/index.vue"),
      },
      // 资讯详情
      {
        path: "/newsDetail",
        name: "newsDetail",
        meta: metaAuth,
        component: () => import("@/views/News/newsDetail.vue"),
      },
      // 关于我们
      {
        path: "/aboutUs",
        name: "aboutUs",
        meta: metaAuth,
        component: () => import("@/views/BottomInfo/aboutUs.vue"),
      },
      // 产品介绍
      {
        path: "/productInfo",
        name: "productInfo",
        meta: metaAuth,
        component: () => import("@/views/BottomInfo/productInfo.vue"),
      },
      // 联系我们
      {
        path: "/contactUs",
        name: "contactUs",
        meta: metaAuth,
        component: () => import("@/views/BottomInfo/contactUs.vue"),
      },
      // 服务条款
      {
        path: "/permit",
        name: "permit",
        meta: metaAuth,
        component: () => import("@/views/BottomInfo/permit.vue"),
      },
      // 软件许可协议
      {
        path: "/softwareLis",
        name: "softwareLis",
        meta: metaAuth,
        component: () => import("@/views/BottomInfo/softwareLis.vue"),
      },
      // 隐私政策
      {
        path: "/privacy",
        name: "privacy",
        meta: metaAuth,
        component: () => import("@/views/BottomInfo/privacy.vue"),
      },
      // 盒子宝典 - 盒子百科
      {
        path: "/boxWiki",
        name: "boxWiki",
        meta: metaAuth,
        component: () => import("@/views/BottomInfo/boxWiki.vue"),
      },
      // 软件许可协议
      {
        path: "/addiction",
        name: "addiction",
        meta: metaAuth,
        component: () => import("@/views/BottomInfo/addiction.vue"),
      },
      // 游戏详情页
      {
        path: "/GameDetail",
        name: "GameDetail",
        meta: metaAuth,
        component: () => import("@/views/GameDetail/index.vue"),
      },
      // 直播
      {
        path: "/liveHome",
        name: "liveHome",
        meta: metaAuth,
        component: () => import("@/views/LiveStreaming/liveHome/index.vue"),
        redirect: "/",
      },
      // 直播详情
      {
        path: "/studio",
        name: "studio",
        meta: metaAuth,
        component: () => import("@/views/LiveStreaming/studio/index.vue"),
      },
      // 百度
      {
        path: "/baidu",
        name: "baidu",
        meta: metaAuth,
        component: () => import("@/views/pinzhuan/index.vue"),
      },
      // zzzj
      {
        path: "/zzzj",
        name: "zzzj",
        meta: metaAuth,
        component: () => import("@/views/zzzj/index.vue"),
      },
      // geo（页面同 /baidu，下载包独立）
      {
        path: "/geo",
        name: "geo",
        meta: metaAuth,
        component: () => import("@/views/pinzhuan/index.vue"),
      },
      // dxaqy（页面同 /baidu，下载包独立）
      {
        path: "/dxaqy",
        name: "dxaqy",
        meta: metaAuth,
        component: () => import("@/views/pinzhuan/index.vue"),
      },
      {
        path: "/biyingjj",
        name: "biyingjj",
        meta: metaAuth,
        component: () => import("@/views/pinzhuan/index.vue"),
      },
      // 拾元立方
      {
        path: "/shiyuanlifang",
        name: "shiyuanlifang",
        meta: metaAuth,
        component: () => import("@/views/shiyuanlifang/index.vue"),
      },
      // 百度
      {
        path: "/bd",
        name: "bd",
        meta: metaAuth,
        component: () => import("@/views/bd/index.vue"),
      },
      // 百度-关于我们
      {
        path: "/bdAboutUs",
        name: "bdAboutUs",
        meta: metaAuth,
        component: () => import("@/views/BottomInfo/aboutUs.vue"),
      },
      // 百度-产品介绍
      {
        path: "/bdproductInfo",
        name: "bdproductInfo",
        meta: metaAuth,
        component: () => import("@/views/BottomInfo/productInfo.vue"),
      },
      // 百度-服务条款
      {
        path: "/bdpermit",
        name: "bdpermit",
        meta: metaAuth,
        component: () => import("@/views/BottomInfo/permit.vue"),
      },
      // 百度-软件许可协议
      {
        path: "/bdsoftwareLis",
        name: "bdsoftwareLis",
        meta: metaAuth,
        component: () => import("@/views/BottomInfo/softwareLis.vue"),
      },
      // 百度-隐私政策
      {
        path: "/bdprivacy",
        name: "bdprivacy",
        meta: metaAuth,
        component: () => import("@/views/BottomInfo/privacy.vue"),
      },
      {
        path: "/tieba",
        name: "tieba",
        meta: metaAuth,
        component: () => import("@/views/tieba/index.vue"),
      },
      // 赛事下载
      {
        path: "/competitionDownload",
        name: "competitionDownload",
        meta: metaAuth,
        component: () => import("@/views/Indexs/competitionDownload.vue"),
      },
      // 发布站落地页一
      {
        path: "/fb1",
        name: "fb1",
        meta: metaAuth,
        component: () => import("@/views/PublishSite/pageTwo/index.vue"),
      },
      // 发布站落地页二
      {
        path: "/fb2",
        name: "fb2",
        meta: metaAuth,
        component: () => import("@/views/PublishSite/pageTwo/index.vue"),
      },
      // 发布站落地页三
      {
        path: "/fb3",
        name: "fb3",
        meta: metaAuth,
        component: () => import("@/views/PublishSite/pageTwo/index.vue"),
      },
      // 发布站落地页 bdfb（基于 fb2，底部公司信息调整）
      {
        path: "/bdfb",
        name: "bdfb",
        meta: metaAuth,
        component: () => import("@/views/PublishSite/pageTwo/index.vue"),
      },
      // 发布站落地页 biyingjjfb（基于 bdfb，底部公司改为杭州闻维，无地址）
      {
        path: "/biyingjjfb",
        name: "biyingjjfb",
        meta: metaAuth,
        component: () => import("@/views/PublishSite/pageTwo/index.vue"),
      },
      // 发布站落地页360sf1
      {
        path: "/360sf1",
        name: "360sf1",
        meta: metaAuth,
        component: () => import("@/views/PublishSite/pageTwo/360sf1.vue"),
      },
      // 发布站步骤说明
      {
        path: "/fb/step",
        name: "fb/step",
        meta: metaAuth,
        component: () => import("@/views/PublishSite/pageStep/index.vue"),
      },
      // 发布站游戏详情
      {
        path: "/fb/gameDetail",
        name: "fb/gameDetail",
        meta: metaAuth,
        component: () => import("@/views/PublishSite/pageGameDetail/index.vue"),
      },
      // 发布站游戏详情360sf1
      {
        path: "/360sf1/gameDetail",
        name: "360sf1/gameDetail",
        meta: metaAuth,
        component: () =>
          import("@/views/PublishSite/pageGameDetail/indexs.vue"),
      },
      // 投放落地页
      {
        path: "/lx",
        name: "lx",
        meta: metaAuth,
        component: () => import("@/views/PublishSite/pageLx/index.vue"),
      },
      // 赛事直播
      // {
      //     path: '/competition',
      //     name: 'competition',
      //     component: () => import('@/views/LiveStreaming/competition/index.vue'),
      // },
      // 360pc
    ],
  },
  // 赛事直播   暂时注释
  // {
  //   path: "/competition",
  //   name: "competition",
  //   meta: metaAuth,
  //   component: () => import("@/views/LiveStreaming/competition/index.vue"),
  // },
  // 赛事2.0
  competitionEvents,
  ...basePc,
  ...baseMb,
  ...basePublish,
  ...basePcThree,
  ...basePcFour,
  {
    path: "/wb/996",
    name: "wb996",
    meta: metaAuth,
    component: () => import("@/views/360/wb/996.vue"),
  },
  {
    path: "/996",
    name: "996",
    meta: metaAuth,
    component: () => import("@/views/996/index.vue"),
  },
  {
    path: "/gt",
    name: "gt",
    meta: metaAuth,
    component: () => import("@/views/gt/index.vue"),
  },
  {
    path: "/basePc",
    name: "basePc",
    meta: metaAuth,
    component: () => import("@/views/basePc/index.vue"),
  },
  {
    path: "/yunyouhuaijiu",
    name: "yunyouhuaijiu",
    meta: metaAuth,
    component: () => import("@/views/yunyouhuaijiu/index.vue"),
  },
  {
    path: "/dydr-yunyou",
    name: "dydr-yunyou",
    meta: metaAuth,
    component: () => import("@/views/dydrYunyou/index.vue"),
  },
  {
    path: "/baidutieba",
    name: "baidutieba",
    meta: metaAuth,
    component: () => import("@/views/baidutieba/index.vue"),
  },
  {
    path: "/dx",
    name: "dx",
    meta: metaAuth,
    component: () => import("@/views/dx/index.vue"),
  },
  {
    path: "/kszb",
    name: "kszb",
    meta: metaAuth,
    component: () => import("@/views/kszb/index.vue"),
  },
  {
    path: "/yunyoutianxia",
    name: "yunyoutianxia",
    meta: metaAuth,
    component: () => import("@/views/yunyoutianxia/index.vue"),
  },
];
